module.exports = __webpack_public_path__ + "img/95115ed5b24f426b5a737628c9b66279.svg";